import { styled, Button, MenuItem, FormControl } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Box } from '@mui/system';

import { Context as FilterContext } from '../context/FilterContext'

// style components
const StyledButton = styled(Button)({
  fontSize: '14px',
  color: '#333', // Dark grey text color
  backgroundColor: '#bfbfbd'
});
const StyledSelect = styled(Select)(({ theme }) => ({
  width: '100%',
}));
const StyledSelectBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  width: '100%'
}));
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
}));


const CategoryFilter = ({ name, category, values, resetCategory }) => {
  const { state } = useContext(FilterContext)

    const [selectedValue, setSelectedValue] = useState(category);

    const handleFilterValueClick = (event) => {
      setSelectedValue(event.target.value);
      resetCategory(event.target.value)
    };

    return (
      <div>
        <StyledSelectBox>
          <FormControl fullWidth>
            <InputLabel key={`${name}-label`} id={`${name}-label`}>{name}</InputLabel>
            <Select
              label={name}
              labelId={`${name}-label`}  
              //value={selectedValue}
              value={selectedValue }
              onChange={handleFilterValueClick}
            >
              {
               Object.keys(values).map((value) => 
                  <StyledMenuItem
                    key={`${name}-${values[value]}`} 
                    value={values[value]}
                  >
                    {value}
                  </StyledMenuItem>
                  )
              }
            </Select>
          </FormControl>
        </StyledSelectBox>
      </div>
    );
}

export default CategoryFilter